import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import styles from "./styles";
import Container from "@material-ui/core/Container";

import { useTranslation } from "react-i18next";
import CustomButton from "../../../../../../Component/CustomButton";

const useStyles = makeStyles(styles);

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const ModalDialog = (props) => {
  const {
    open = false,
    onClose,
    onSubmit,
    children,
    title,
    fullWidth = false,
    maxWidth = "md",
    dialogClasses
  } = props;
  const { t } = useTranslation();

  const classes = useStyles();

  return (
    <Dialog
      disableBackdropClick
      onClose={onClose}
      aria-labelledby="add-document-modal"
      open={open}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      scroll={'paper'}
      style={{ width: "auto" }}
      classes={dialogClasses}
    >
      <DialogTitle id="add-document-modal" onClose={onClose}>
        <Typography className={classes.panelTitle}>{title}</Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Container>{children}</Container>
      </DialogContent>
      <DialogActions>
        <CustomButton variant="secondary" onClick={onClose}>
          {t("labels.common.close")}
        </CustomButton>
        <CustomButton variant="primary" onClick={onSubmit}>
          {t("labels.common.submit")}
        </CustomButton>

      </DialogActions>
    </Dialog>
  );
};

export default ModalDialog;
